import(/* webpackMode: "eager" */ "/codebuild/output/src3823956198/src/legalo/src/app/registro/tipo/page.tsx");
